module.exports = __webpack_public_path__ + "assets/img/_Novo RDR_Clubhouse Night_RGB_lr.7bb646ab.jpg";